import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import pDebounce from 'p-debounce';

import { getTokenWithType } from './useAuth';

import { customLookupTables as getCustomTable } from '../utils/urls';

import { CustomTable } from 'types/customTables';
import { ErrorModal } from 'types/modalTypes';

async function fetchCustomTable({ accountId }: TVariables): Promise<TResult> {
  const response = await fetch(getCustomTable(accountId), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
  return response.json();
}

const debouncedFetch = pDebounce(fetchCustomTable, 500);

type TError = ErrorModal;

type TResult = {
  Data: Array<CustomTable>;
  IsSuccess: boolean;
  StatusCode: number;
};

type TVariables = {
  accountId: number;
};

function useGetCustomTable(
  accountId: number,
): UseInfiniteQueryResult<TResult, TError> {
  return useInfiniteQuery(
    ['get_custom_table', accountId],
    () => debouncedFetch({ accountId }),
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetCustomTable };
